// extracted by mini-css-extract-plugin
export default {"VariableTooltip-heading":"VariableTooltip-heading2Mz_jSnYLn3m"};